module.exports = __webpack_public_path__ + "img/conoce_nuestros_productos.3fdd8f12.png";